export const Banners =
  process.env.REACT_APP_ENV === 'prod'
    ? {
        aQWwv3TglOcD4h5FYAP82VpiQFfRKXja: {
          message: 'education',
          name: 'Science Kit',
        },
        xOc9U0Y4M5K8oUrZ0z1tt3mmdhRquBKW: {
          message: 'education',
          name: 'Edu Classroom Dashboard',
        },
        qtdvDW7jM37RAMdCaFcLDzxJikyTMhP6: {
          message: 'education',
          name: 'Edu Landing',
        },
        V4xgjDgZd1pw3qUEghWvdPXz2Oy87B1C: {
          message: 'education',
          name: 'Edu Remote Landing',
        },
        '0VGCZfbr9Zdryphu6kVjtvSRL359hlLG': {
          message: 'education',
          name: 'Ctc Go Motion',
        },
      }
    : {
        JpA1wgCXe2FWWC8BbJG7fxuSacmZ3gz2: {
          message: 'education',
          name: 'Science Kit',
        },
        CtqJR5I19oA10wolWWL4gROUl47qMJ6p: {
          message: 'education',
          name: 'Edu Classroom Dashboard',
        },
        '0P2eUJbCDUFdF5mGdgz9YmwY093fXMmK': {
          message: 'education',
          name: 'Edu Landing',
        },
        ZNMV8YFOpE0tIdP5a8ds5UjVcgdVOiIy: {
          message: 'education',
          name: 'Edu Remote Landing',
        },
        '4cdP7POj2JqXVkw7bJVxi9FlCSovSIev': {
          message: 'education',
          name: 'Ctc Go Motion',
        },
        mJGEf7gQXid1V3kyzeDBTDRAZKC1hg3v: {
          message: 'Test message',
          name: 'Local Development Test',
        },
      };

export const OldUserLoginSbackbarMessageApps =
  process.env.REACT_APP_ENV === 'prod'
    ? ['aQWwv3TglOcD4h5FYAP82VpiQFfRKXja', 'xOc9U0Y4M5K8oUrZ0z1tt3mmdhRquBKW']
    : ['JpA1wgCXe2FWWC8BbJG7fxuSacmZ3gz2', 'CtqJR5I19oA10wolWWL4gROUl47qMJ6p'];
